import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useTheme as useCustomTheme } from '../../ThemeContext';
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
// import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
// import AccountCircle from "@material-ui/icons/AccountCircle";
// import { IoArrowRedoOutline } from "react-icons/io5";
// import Tooltip from "@material-ui/core/Tooltip";
import AuthApi from "../Services/Authapi";
import ls from "local-storage";
import Logo from "../../Images/logo.png";
import defaultAvatar from "../../Images/person.jpg";
import FontAwesomeIconComponent from "./FontAwesomeIconComponent";
import Tooltip from "@material-ui/core/Tooltip";
// import { revokeAccess } from "../../ScreenShot";
// import Button from "@material-ui/core/Button";
// import Fade from "@material-ui/core/Fade";
// import Grow from "@material-ui/core/Grow";
// import Paper from "@material-ui/core/Paper";
// import Popper from "@material-ui/core/Popper";
// import ClickAwayListener from "@material-ui/core/ClickAwayListener";
// import MenuList from "@material-ui/core/MenuList";
import { Collapse } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useHistory } from 'react-router-dom';
// import StarBorder from "@material-ui/icons/StarBorder";
// import { useState } from "react";
// import Badge from "@mui/material/Badge";
// import MailIcon from "@mui/icons-material/Mail";
// import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Notification from "./Notification";
import swal from 'sweetalert';
import "./header.css"
// import ls from "local-storage";
import Switch from "react-switch";
import {
  canCurrentUserToggleRole,
  getPrimaryRoleFromUser,
  persistStoredRole,
  persistStoredUser,
  syncRoleToggleEligibility,
} from "../../utils/authSession";
// import Timer from "../Pages/TImer/timer";

const drawerWidth = 240;

const getStoredSidebarOpen = () => {
  const saved = ls.get("sidebarOpen");
  if (saved === true || saved === false) {
    return saved;
  }

  return false;
};

const normalizePermissionList = (value) => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((permission) => typeof permission === "string" && permission.trim() !== "");
};

const getPermissionsFromUser = (user) => {
  if (!user || !Array.isArray(user.roles)) {
    return [];
  }

  return user.roles.flatMap((role) => {
    if (!role || !Array.isArray(role.permissions)) {
      return [];
    }

    return role.permissions
      .map((permission) => permission?.name)
      .filter((permissionName) => typeof permissionName === "string" && permissionName.trim() !== "");
  });
};

const sidebarIconConfig = {
  dashboard: {
    key: "dashboard",
    path: "/dashboard",
    icon: "fa fa-home",
    title: "Dashboard",
    color: "#036dda",
    activeBg: "rgba(3,109,218,0.12)",
    idleBg: "rgba(3,109,218,0.05)",
  },
  attendance: {
    key: "attendance",
    path: "/attendance",
    icon: "far fa-calendar-alt",
    title: "Attendance",
    color: "#6366F1",
    activeBg: "rgba(208,199,247,0.25)",
    idleBg: "rgba(99,102,241,0.08)",
    permission: "Attendance.Show",
  },
  holidayLeaves: {
    key: "holiday-leaves",
    path: "/holiday-leaves",
    icon: "fas fa-sign-out-alt",
    title: "Leaves & Holidays",
    color: "#F59E0B",
    activeBg: "rgba(245,158,11,0.16)",
    idleBg: "rgba(245,158,11,0.08)",
    permission: "Holidays.Show",
  },
  upcomingEvent: {
    key: "upcoming-event",
    path: "/upcoming-event",
    icon: "fa fa-arrow-right",
    title: "Upcoming Event",
    color: "#F43F5E",
    activeBg: "rgba(244,63,94,0.18)",
    idleBg: "rgba(244,63,94,0.08)",
    permission: "Upcomingevent.Show",
  },
  leaveTickets: {
    key: "leave-tickets",
    path: "/leave-tickets",
    icon: "fas fa-ticket-alt",
    title: "Leave Tickets",
    color: "#64748B",
    activeBg: "rgba(100,116,139,0.18)",
    idleBg: "rgba(100,116,139,0.08)",
    permission: "Leaveticket.Show",
  },
  timeEntries: {
    key: "time-entries",
    path: "/time-entries",
    icon: "fas fa-clipboard-check",
    title: "User Check",
    color: "#8B5CF6",
    activeBg: "rgba(139,92,246,0.18)",
    idleBg: "rgba(139,92,246,0.08)",
    permission: "Timeentry.Show",
  },
  cron: {
    key: "cron",
    path: "/cron",
    icon: "fas fa-clock",
    title: "Cron",
    color: "#EF4444",
    activeBg: "rgba(239,68,68,0.18)",
    idleBg: "rgba(239,68,68,0.08)",
    permission: "Cron.Show",
  },
  settings: {
    key: "settings",
    path: "/settings",
    icon: "fa fa-cog",
    title: "Settings",
    color: "#6B7280",
    activeBg: "rgba(107,114,128,0.18)",
    idleBg: "rgba(107,114,128,0.08)",
    permission: "Settings.Show",
  },
};

const SidebarIconButton = ({ icon, title, color, activeBg, idleBg, isActive, onClick }) => (
  <Tooltip title={title} placement="right">
    <button
      type="button"
      aria-label={title}
      className={clsx("sidebar-icon-btn", { active: isActive })}
      style={{
        "--sidebar-icon-color": color,
        "--sidebar-icon-border-color": color,
        "--sidebar-icon-active-bg": activeBg,
        "--sidebar-icon-idle-bg": idleBg,
      }}
      onClick={onClick}
    >
      <i className={icon} aria-hidden="true" />
    </button>
  </Tooltip>
);



const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    // hide default scrollbars in the sidebar
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    minWidth: 0,
  },
  ds: {
    position: "absolute",
    right: 0,
  },
  back: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  activeMenuItem: {
    backgroundColor:
      theme.palette.type === "dark"
        ? "#1f2933"
        : "#e3e6f1",
    color: theme.palette.type === "dark" ? "#ffffff" : "inherit",
  },
}));

export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { darkMode, toggleTheme } = useCustomTheme();
  const [open, setOpen] = React.useState(() => getStoredSidebarOpen());

  React.useEffect(() => {
    ls.set("sidebarOpen", open);
  }, [open]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const opens = Boolean(anchorEl);
  // Define route groups used by collapsible sections
  const jobPortalPaths = ["/job", "/qulification", "/experience", "/designation", "/Departmente"];
  const userGroupPaths = ["/permission", "/role", "/users"];
  const taskManagementPaths = ["/project", "/tasks"];
  const documentsPaths = ["/documents/documents-list", "/templates", "/email-templates"];
  const feedbackPaths = ["/form360", "/review-form-list"];

  // Initialize open states based on current route to avoid initial flicker
  const currentPathInit = typeof window !== "undefined" ? window.location.pathname : "";
  const [ds, setDs] = React.useState(jobPortalPaths.includes(currentPathInit));
  const [ds1, setDs1] = React.useState(feedbackPaths.includes(currentPathInit));
  const [ds2, setDs2] = React.useState(taskManagementPaths.includes(currentPathInit));
  const [docu, setDocu] = React.useState(documentsPaths.includes(currentPathInit));
  const [user, setuser] = React.useState(userGroupPaths.includes(currentPathInit));
  const [userimg1, setuserimg] = React.useState([]);
  const history = useHistory();

  const handleClick1 = () => {
    setDs1(!ds1);
  };
  const handleClick2 = () => {
    setDs2(!ds2);
  };



  const handleClick = () => {
    setDs(!ds);
  };
  const usersClick = () => {
    setuser(!user);
  };



  const DocumentClick = () => {
    setDocu(!docu);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    userimg();
  }, []);

  const userimg = async (e) => {
    let users = await AuthApi.userimg();
    setuserimg(users);
  };

  const clearClientAuthState = () => {
    ls.set("authToken", false);
    ls.set("isActive", false);
    ls.set("roles", false);
    ls.set("user", false);

    try {
      const existingSnapshot = JSON.parse(window.localStorage.getItem("ems_timer_snapshot") || "{}");
      const now = new Date();
      const dateKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      const preservedTotal = Number(existingSnapshot?.totaltimer) || 0;

      window.localStorage.removeItem("authToken");
      window.localStorage.removeItem("roles");
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("tokenRefreshed");
      window.localStorage.setItem("ems_timer_snapshot", JSON.stringify({
        timer: 0,
        totaltimer: preservedTotal,
        isActive: false,
        savedAt: Date.now(),
        dateKey,
      }));
      window.localStorage.removeItem("ems_auto_timer_session_started_at");
    } catch (err) { }
  };

  const preserveThemePreference = () => {
    try {
      const storedTheme = window.localStorage.getItem("theme");
      return storedTheme === "dark" || storedTheme === "light" ? storedTheme : null;
    } catch (error) {
      return null;
    }
  };

  const restoreThemePreference = (themeName) => {
    if (!themeName) {
      return;
    }

    try {
      const isDark = themeName === "dark";
      window.localStorage.setItem("theme", themeName);
      document.body.classList.toggle("dark-theme", isDark);
      document.documentElement.setAttribute("data-theme", themeName);
      document.documentElement.style.setProperty("color-scheme", themeName);
    } catch (error) {}
  };

  const logOut = async (e) => {
    handleClose();
    const redirectPath = "/login";
    const preservedTheme = preserveThemePreference();

    try {
      try {
        window.sessionStorage.setItem("postLogoutLoginRoute", redirectPath);
      } catch (storageError) {}

      await outTimer();
      await AuthApi.logout();
    } catch (error) {
      console.error("Logout sync failed: ", error);
    } finally {
      clearClientAuthState();
      props.setAutUser({ authToken: false, authUser: false });
      ls.clear();
      restoreThemePreference(preservedTheme);
      window.location.replace(redirectPath);
    }
  };

  const outTimer = async (e) => {
    try {
      await AuthApi.outTime();
    } catch (error) {
      console.error("Clock-out during logout failed:", error);
    }
  };

  const hhhh = window.location.pathname;
  const permissionsFromProps = normalizePermissionList(props.authUser?.userAccess);
  const permissionsFromStorage = normalizePermissionList(ls("userAccess"));
  const permissionsFromStoredUser = getPermissionsFromUser(ls("user"));
  const permissions = permissionsFromProps.length > 0
    ? permissionsFromProps
    : (permissionsFromStorage.length > 0 ? permissionsFromStorage : permissionsFromStoredUser);

  const navigateTo = (path) => (event) => {
    event.preventDefault();
    history.push(path);
  };

  const renderIconGroup = (keys) => {
    const configs = keys
      .map((key) => {
        const config = sidebarIconConfig[key];
        if (!config) return null;
        if (config.permission && !permissions.includes(config.permission)) return null;
        return config;
      })
      .filter(Boolean);

    if (!configs.length) {
      return null;
    }

    // Compact sidebar: show only circular icon buttons in a vertical stack
    if (!open) {
      return (
        <div className="sidebar-icon-stack">
          {configs.map((config) => (
            <SidebarIconButton
              key={config.key}
              {...config}
              isActive={hhhh === config.path}
              onClick={navigateTo(config.path)}
            />
          ))}
        </div>
      );
    }

    // Expanded sidebar: show full-width list items with labels
    return (
      <>
        {configs.map((config) => {
          const isActive = hhhh === config.path;
          return (
            <ListItem
              key={config.key}
              button
              onClick={navigateTo(config.path)}
              className={clsx(isActive && classes.activeMenuItem)}
              style={{
                width: "calc(100% - 12px)",
                marginLeft: 6,
                paddingLeft: 12,
                paddingRight: 12,
                marginBottom: 20,
                height: 48,
                borderRadius: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 10,
                cursor: "pointer",
                transition: "0.25s",
                boxShadow: "0 0 6px rgba(0,0,0,0.2)",
                backgroundColor: isActive
                  ? config.activeBg
                  : config.idleBg,
                border: isActive
                  ? `2px solid ${config.color}`
                  : "2px solid transparent",
              }}
            >
              <ListItemIcon style={{
                minWidth: 48,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
              }}>
                <i
                  className={config.icon}
                  style={{
                    width: 24,
                    textAlign: "center",
                    color: config.color,
                    fontSize: 18,
                  }}
                ></i>
              </ListItemIcon>
              <ListItemText primary={config.title} />
            </ListItem>
          );
        })}
      </>
    );
  };

  const getParentItemStyle = ({ isActive, activeBg, idleBg, color }) => ({
    width: open ? "calc(100% - 12px)" : 48,
    height: 48,
    borderRadius: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: open ? "flex-start" : "center",
    gap: open ? 10 : 0,
    cursor: "pointer",
    transition: "0.3s",
    marginLeft: 6,
    paddingLeft: open ? 12 : 0,
    paddingRight: open ? 12 : 0,
    background: isActive ? activeBg : idleBg,
    border: isActive ? `2px solid ${color}` : "2px solid transparent",
    boxShadow: "0 0 6px rgba(0,0,0,0.2)",
  });

  const parentIconProps = {
    style: {
      minWidth: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 48,
    },
  };

  const renderParentIconContent = ({ iconClass, color, expanded }) => {
    const icon = (
      <FontAwesomeIconComponent
        classes={iconClass}
        colorName="primary"
        style={{ color }}
        fontSize={"small"}
      />
    );

    if (open) {
      return icon;
    }

    return (
      <div className="sidebar-parent-collapsed-icon">
        <span className="sidebar-parent-icon">{icon}</span>
        <span className="sidebar-parent-arrow sidebar-parent-arrow--overlay">
          {expanded ? (
            <ExpandLess style={{ fontSize: 16, color }} />
          ) : (
            <ExpandMore style={{ fontSize: 16, color }} />
          )}
        </span>
      </div>
    );
  };


  const toggleRole = async () => {
    try {
      const storedUser = ls("user");
      if (!storedUser || !storedUser.id) return;
      const response = await AuthApi.toggleRole(storedUser.id);
      if (response && response.status === true) {
        await handleRefresh1();
        await getAuth();
      }
    } catch (error) {
      alert('An error occurred');
    }
  };

  const storedUser = ls("user") || null;
  const is_role_toggled = storedUser && typeof storedUser.is_role_toggled !== "undefined" ? storedUser.is_role_toggled : 0;
  const role = ls("roles") || "";
  const canToggleRole = canCurrentUserToggleRole({ user: storedUser, role });

  const getAuth = async () => {
    swal({
      title: "Loading...",
      text: "Please wait while we changing your interface.",
      icon: "info",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });

    let checkLogin = await AuthApi.checkAuth();
    if (checkLogin && checkLogin.status !== false) {
      const authenticatedUser = checkLogin.data?.user || false;
      const resolvedRole =
        getPrimaryRoleFromUser(authenticatedUser) || ls("roles") || "";

      persistStoredUser(authenticatedUser);
      persistStoredRole(resolvedRole);
      syncRoleToggleEligibility({
        user: authenticatedUser,
        role: resolvedRole,
      });
      window.location.reload();
    } else {
      ls.set("roles", false);
      ls.set("authToken", false);
      ls.set("user", false);
      props.setAutUser({
        authUser: false,
        authToken: false,
        roles: false,
        user: false,
      });
      swal.close();
    }
  };



  const handleRefresh1 = async () => {
    try {
      const currentUser = ls("user");
      if (!currentUser || !currentUser.id) return;
      let formData = { user_id: currentUser.id };
      const newToken = await AuthApi.refreshToken(formData);
      localStorage.setItem('authToken', newToken.access_token);
      persistStoredRole(newToken.roles);
      localStorage.setItem('tokenRefreshed', 'true');

      if (currentUser) {
        syncRoleToggleEligibility({
          user: currentUser,
          role: newToken.roles,
        });
      }

      // window.location.reload();
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
  };


  const doj = storedUser && storedUser.doj ? new Date(storedUser.doj) : null;
  const currentDate = new Date();
  const monthsDifference = doj ? ((currentDate.getFullYear() - doj.getFullYear()) * 12 + currentDate.getMonth() - doj.getMonth()) : 0;
  const reviewFormStatus = storedUser && typeof storedUser.Review_form_status !== "undefined" ? storedUser.Review_form_status : 0;

  const handleEditProfile = () => {
    const currentUser = ls("user");
    if (!currentUser || !currentUser.id) {
      history.push("/login");
      return;
    }
    const userId = currentUser.id;
    const randomString = Math.random().toString(36).substring(2, 8);
    const combinedString = `${userId}-${randomString}`;
    const encodedUserId = btoa(combinedString);
    history.push(`/users/${encodedUserId}`);
  };

  // Auto-open collapsible groups based on the current route
  useEffect(() => {
    const jobPortalPaths = ["/job", "/qulification", "/experience", "/designation", "/Departmente"];
    const userGroupPaths = ["/permission", "/role", "/users"];
    const taskManagementPaths = ["/project", "/tasks"];
    const documentsPaths = ["/documents/documents-list", "/templates", "/email-templates"];
    const feedbackPaths = ["/form360", "/review-form-list"];

    setDs(jobPortalPaths.includes(hhhh));
    setuser(userGroupPaths.includes(hhhh));
    setDs2(taskManagementPaths.includes(hhhh));
    setDocu(documentsPaths.includes(hhhh));
    setDs1(feedbackPaths.includes(hhhh));
  }, [hhhh]);

  const [presence, setPresence] = React.useState(null);
  const userId = ls.get('user')?.id;
  React.useEffect(() => {
    let mounted = true;
    AuthApi.getEmployeePresenceMap().then(res => {
      if (mounted && res && res.status && Array.isArray(res.data) && userId) {
        setPresence(res.data.find(emp => String(emp.user_id) === String(userId)));
      }
    });
    return () => { mounted = false; };
  }, [userId]);

  const STATUS_COLORS = {
    'Working': '#28a745',
    'On Break': '#ffc107',
    'Offline': '#dc3545',
    'Absent': '#6c757d'
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, "common-layout-header", {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, "header-menu-toggle", {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Tooltip
            title={presence ? `Status: ${presence.status}${presence.since ? ` (${presence.since})` : ''}` : 'Loading status...'}
            arrow
            placement="bottom"
          >
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              className={classes.ds}
              color="inherit"
              style={{ padding: 6 }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  padding: '2px',
                  border: `4px solid ${presence ? (STATUS_COLORS[presence.status] || '#888') : 'transparent'}`,
                  background: '#fff',
                }}
              >
                <img
                  src={(userimg1 && userimg1.data && String(userimg1.data).trim() !== "") ? userimg1.data : defaultAvatar}
                  alt="User"
                  style={{ width: "30px", height: "30px", borderRadius: "50%", display: "block" }}
                />
              </span>
            </IconButton>
          </Tooltip>





          {canToggleRole ? (
            <Tooltip title={is_role_toggled === 1 ? "Switch to Super Admin " : "Switch to Employee"}>
              <label
                style={{
                  position: "absolute",
                  right: "96px",
                  height: "28px",
                  display: "inline-block"
                }}
              >
                <Switch
                  onChange={toggleRole}
                  checked={Boolean(is_role_toggled)}
                  width={56}
                  height={28}
                  handleDiameter={20}
                />
              </label>
            </Tooltip>
          ) : null}

          <div
            className="header-auto-timer-control"
            style={{
              right: canToggleRole ? "160px" : "102px",
            }}
          >
            <Tooltip title="Toggle Theme">
              <label
                className="switch"
                style={{
                  position: "relative",
                  right: "auto",
                  width: "56px",
                  height: "28px",
                  display: "inline-block"
                }}
              >
                <input id="input" type="checkbox" checked={darkMode} onChange={toggleTheme} />
                <div className="slider round">
                  <div className="sun-moon">
                    <svg id="moon-dot-1" className="moon-dot" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="moon-dot-2" className="moon-dot" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="moon-dot-3" className="moon-dot" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="light-ray-1" className="light-ray" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="light-ray-2" className="light-ray" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="light-ray-3" className="light-ray" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-1" className="cloud-dark" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-2" className="cloud-dark" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-3" className="cloud-dark" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-4" className="cloud-light" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-5" className="cloud-light" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                    <svg id="cloud-6" className="cloud-light" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="50"></circle>
                    </svg>
                  </div>
                  <div className="stars">
                    <svg id="star-1" className="star" viewBox="0 0 20 20">
                      <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"></path>
                    </svg>
                    <svg id="star-2" className="star" viewBox="0 0 20 20">
                      <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"></path>
                    </svg>
                  <svg id="star-3" className="star" viewBox="0 0 20 20">
                    <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"></path>
                  </svg>
                  <svg id="star-4" className="star" viewBox="0 0 20 20">
                    <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"></path>
                  </svg>
                </div>
              </div>
            </label>
          </Tooltip>
          </div>

          <Notification
            {...props}
          />



          <Menu
            style={{
              top: "48px",
            }}
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={opens}
            onClose={handleClose}
          >
            <div
              style={{
                width: "200px",
              }}
            >
              {/* // ... existing code ... */}
              <MenuItem
                onClick={handleEditProfile}
                primary="Profile"
                title="Profile"
                placement="right"
              >
                {/* // ... existing code ... */}
                <FontAwesomeIconComponent
                  classes="fas fa-user-circle"
                  colorName="primary"
                  fontSize={"small"}
                  style={{ color: "var(--hrms-primary-blue-end, #036dda)" }}
                />
                <span style={{ marginLeft: "15px" }}>Edit Profile</span>
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  logOut(e);
                }}
              >
                <FontAwesomeIconComponent
                  classes="fas fa-sign-out-alt"
                  colorName="primary"
                  fontSize={"small"}
                  style={{ color: "var(--hrms-primary-blue-end, #036dda)" }}
                />
                <span style={{ marginLeft: "15px" }}> Sign Out</span>
              </MenuItem>
            </div>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        
        <div className={classes.toolbar}>
          <img
            style={{ height: "35px", paddingRight: "30px" }}
            src={Logo}
            alt="ds"
          />
          <h1 style={{ fontSize: "20px", paddingRight: "20px" }}>CPSI EMS</h1>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          <div style={{ marginTop: "20px", marginBottom: open ? "20px" : "6px" }}>
            {renderIconGroup(["dashboard", "attendance"])}
          </div>

          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {(permissions.includes("Permission.Show") ||
              permissions.includes("Role.Show") ||
              permissions.includes("Users.Show")) && (
                <div>

                  {/* ==== PARENT USERS BUTTON (Dashboard Style) ==== */}
                  <ListItem
                    className="sidebar-parent"
                    button
                    onClick={usersClick}
                    style={getParentItemStyle({
                      isActive:
                        hhhh === "/permission" ||
                        hhhh === "/role" ||
                        hhhh === "/users",
                      activeBg: "rgba(16,185,129,0.12)",
                      idleBg: "rgba(16,185,129,0.05)",
                      color: "#10B981",
                    })}
                  >
                    <Tooltip title="Users">
                      <ListItemIcon {...parentIconProps}>
                        {renderParentIconContent({
                          iconClass: "far fa-file-alt",
                          color: "#10B981",
                          expanded: user,
                        })}
                      </ListItemIcon>
                    </Tooltip>

                    {open && <ListItemText primary="Users" />}

                    {open && (
                      <span className="sidebar-parent-arrow sidebar-parent-arrow--right">
                        {user ? (
                          <ExpandLess style={{ color: "#10B981" }} />
                        ) : (
                          <ExpandMore style={{ color: "#10B981" }} />
                        )}
                      </span>
                    )}
                  </ListItem>

                  {/* ==== COLLAPSE MENU ==== */}
                  <Collapse in={user} timeout="auto" unmountOnExit>
                    <List disablePadding style={{ marginTop: 12 }}>

                      {/* PERMISSION */}
                      {permissions.includes("Permission.Show") && (
                        <Tooltip title="Permission">
                          <ListItem
                            button
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/permission");
                            }}
                            className={clsx(
                              hhhh === "/permission" && classes.activeMenuItem
                            )}
                            style={{
                              width: open ? "calc(100% - 12px)" : 48,
                              marginLeft: 6,
                              marginBottom: 12,
                              height: 48,
                              borderRadius: 14,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: open ? "flex-start" : "center",
                              paddingLeft: open ? 12 : 0,
                              paddingRight: open ? 12 : 0,
                              transition: "0.3s",
                              boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                              background:
                                hhhh === "/permission"
                                  ? "rgba(16,185,129,0.12)"
                                  : "rgba(16,185,129,0.05)",

                              border:
                                hhhh === "/permission"
                                  ? "2px solid #10B981"
                                  : "2px solid transparent",
                            }}
                          >
                            <ListItemIcon style={{
                              minWidth: 48,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 48,
                            }}>
                              <i
                                className="fa fa-lock"
                                style={{ width: 24, textAlign: "center", fontSize: 18, color: "#10B981" }}
                              ></i>
                            </ListItemIcon>

                            {open && <ListItemText primary="Manage Permission" />}
                            {open && hhhh === "/permission" && (
                              <i
                                // className="fa fa-chevron-right"
                                style={{
                                  marginLeft: "auto",
                                  fontSize: 12,

                                }}
                              ></i>
                            )}
                          </ListItem>
                        </Tooltip>
                      )}

                      {/* ROLE */}
                      {permissions.includes("Role.Show") && (
                        <Tooltip title="Role">
                          <ListItem
                            button
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/role");
                            }}
                            className={clsx(
                              hhhh === "/role" && classes.activeMenuItem
                            )}
                            style={{
                              width: open ? "calc(100% - 12px)" : 48,
                              marginLeft: 6,
                              marginBottom: 12,
                              height: 48,
                              borderRadius: 14,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: open ? "flex-start" : "center",
                              paddingLeft: open ? 12 : 0,
                              paddingRight: open ? 12 : 0,
                              transition: "0.3s",
                              boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                              background:
                                hhhh === "/role"
                                  ? "rgba(16,185,129,0.12)"
                                  : "rgba(16,185,129,0.05)",

                              border:
                                hhhh === "/role"
                                  ? "2px solid #10B981"
                                  : "2px solid transparent",
                            }}
                          >
                            <ListItemIcon style={{
                              minWidth: 48,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 48,
                            }}>
                              <i
                                className="fas fa-user-cog"
                                style={{ width: 24, textAlign: "center", fontSize: 18, color: "#10B981" }}
                              ></i>
                            </ListItemIcon>

                            {open && <ListItemText primary="Manage Role" />}
                            {open && hhhh === "/role" && (
                              <i
                                // className="fa fa-chevron-right"
                                style={{
                                  marginLeft: "auto",
                                  fontSize: 12,
                                  color: "#10B981",
                                }}
                              ></i>
                            )}
                          </ListItem>
                        </Tooltip>
                      )}

                      {/* USERS */}
                      {permissions.includes("Users.Show") && (
                        <Tooltip title="Users">
                          <ListItem
                            button
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/users");
                            }}
                            className={clsx(
                              hhhh === "/users" && classes.activeMenuItem
                            )}
                            style={{
                              width: open ? "calc(100% - 12px)" : 48,
                              marginLeft: 6,
                              marginBottom: 12,
                              height: 48,
                              borderRadius: 14,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: open ? "flex-start" : "center",
                              paddingLeft: open ? 12 : 0,
                              paddingRight: open ? 12 : 0,
                              transition: "0.3s",
                              boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                              background:
                                hhhh === "/users"
                                  ? "rgba(16,185,129,0.12)"
                                  : "rgba(16,185,129,0.05)",

                              border:
                                hhhh === "/users"
                                  ? "2px solid #10B981"
                                  : "2px solid transparent",
                            }}
                          >
                            <ListItemIcon style={{
                              minWidth: 48,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 48,
                            }}>
                              <i
                                className="fas fa-users"
                                style={{ width: 24, textAlign: "center", fontSize: 18, color: "#10B981" }}
                              ></i>
                            </ListItemIcon>

                            {open && <ListItemText primary="Manage Users" />}
                            {open && hhhh === "/users" && (
                              <i
                                // className="fa fa-chevron-right"
                                style={{
                                  marginLeft: "auto",
                                  fontSize: 12,
                                  color: "#10B981",
                                }}
                              ></i>
                            )}
                          </ListItem>
                        </Tooltip>
                      )}

                    </List>
                  </Collapse>
                </div>
              )}
          </div>

          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {renderIconGroup(["holidayLeaves", "upcomingEvent", "leaveTickets"])}
          </div>
          {/* ================== JOB PORTAL PARENT BUTTON ================== */}
          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {(permissions.includes("Job.Show") ||
              permissions.includes("Qualification.Show") ||
              permissions.includes("Experience.Show") ||
              permissions.includes("Department.Show") ||
              permissions.includes("designation.Show")) && (
                <ListItem
                  className="sidebar-parent"
                  button
                  onClick={handleClick}
                  style={getParentItemStyle({
                    isActive:
                      hhhh === "/job" ||
                      hhhh === "/qulification" ||
                      hhhh === "/experience" ||
                      hhhh === "/designation" ||
                      hhhh === "/Departmente",
                    activeBg: "rgba(14,165,233,0.12)",
                    idleBg: "rgba(14,165,233,0.05)",
                    color: "#036dda",
                  })}
                >
                  <Tooltip title="Job-Portal">
                    <ListItemIcon {...parentIconProps}>
                      {renderParentIconContent({
                        iconClass: "fas fa-briefcase",
                        color: "#036dda",
                        expanded: ds,
                      })}
                    </ListItemIcon>
                  </Tooltip>

                  {open && <ListItemText primary="Job-Portal" />}

                  {open && (
                    <span className="sidebar-parent-arrow sidebar-parent-arrow--right">
                      {ds ? (
                        <ExpandLess style={{ color: "#036dda" }} />
                      ) : (
                        <ExpandMore style={{ color: "#036dda" }} />
                      )}
                    </span>
                  )}
                </ListItem>
              )}

            {/* ================== COLLAPSE ================== */}
            <Collapse in={ds} timeout="auto" unmountOnExit>
              <List disablePadding style={{ marginTop: 12 }}>

                {/* ===== JOB ===== */}
                {permissions.includes("Job.Show") && (
                  <Tooltip title="Job">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/job");
                      }}
                      className={clsx(
                        hhhh === "/job" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/job"
                            ? "rgba(14,165,233,0.12)"
                            : "rgba(14,165,233,0.05)",
                        border:
                          hhhh === "/job"
                            ? "2px solid #0EA5E9"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fa fa-suitcase"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#036dda" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText primary="Job" />}
                      {open && hhhh === "/job" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#036dda",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* ===== QUALIFICATION ===== */}
                {permissions.includes("Qualification.Show") && (
                  <Tooltip title="Qualification">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/qulification");
                      }}
                      className={clsx(
                        hhhh === "/qulification" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/qulification"
                            ? "rgba(14,165,233,0.12)"
                            : "rgba(14,165,233,0.05)",
                        border:
                          hhhh === "/qulification"
                            ? "2px solid #0EA5E9"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fa fa-graduation-cap"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#036dda" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText primary="Qualification" />}
                      {open && hhhh === "/qulification" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#036dda",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* ===== EXPERIENCE ===== */}
                {permissions.includes("Experience.Show") && (
                  <Tooltip title="Experience">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/experience");
                      }}
                      className={clsx(
                        hhhh === "/experience" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/experience"
                            ? "rgba(14,165,233,0.12)"
                            : "rgba(14,165,233,0.05)",
                        border:
                          hhhh === "/experience"
                            ? "2px solid #0EA5E9"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fa fa-business-time"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#036dda" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText primary="Experience" />}
                      {open && hhhh === "/experience" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#036dda",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* ===== DESIGNATION ===== */}
                {permissions.includes("designation.Show") && (
                  <Tooltip title="All Designation">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/designation");
                      }}
                      className={clsx(
                        hhhh === "/designation" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/designation"
                            ? "rgba(14,165,233,0.12)"
                            : "rgba(14,165,233,0.05)",
                        border:
                          hhhh === "/designation"
                            ? "2px solid #0EA5E9"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fas fa-user-tie"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#036dda" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText primary="All Designation" />}
                      {open && hhhh === "/designation" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#036dda",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* ===== DEPARTMENT ===== */}
                {permissions.includes("Department.Show") && (
                  <Tooltip title="All Department">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/Departmente");
                      }}
                      className={clsx(
                        hhhh === "/Departmente" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/Departmente"
                            ? "rgba(14,165,233,0.12)"
                            : "rgba(14,165,233,0.05)",
                        border:
                          hhhh === "/Departmente"
                            ? "2px solid #0EA5E9"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fas fa-building"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#036dda" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText primary="All Department" />}
                      {open && hhhh === "/Departmente" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#036dda",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

              </List>
            </Collapse>
          </div>

          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {renderIconGroup(["timeEntries"])}
          </div>

          <div style={{ marginBottom: open ? "20px" : "12px" }}>
            {/* ================== TASK MANAGEMENT (Dashboard Style) ================== */}

            {/*
            {(permissions.includes("Project.Show") || permissions.includes("Tasks.Show")) && (
              <ListItem
                className="sidebar-parent"
                button
                onClick={handleClick2}
                style={getParentItemStyle({
                  isActive: hhhh === "/project" || hhhh === "/tasks",
                  activeBg: "rgba(16,185,129,0.12)",
                  idleBg: "rgba(16,185,129,0.05)",
                  color: "#10B981",
                })}
              >
                <Tooltip title="Task Management">
                  <ListItemIcon {...parentIconProps}>
                    {renderParentIconContent({
                      iconClass: "fas fa-clipboard-list",
                      color: "#34D399",
                      expanded: ds2,
                    })}
                  </ListItemIcon>
                </Tooltip>

                {open && <ListItemText primary="Task Management" />}

                {open && (
                  <span className="sidebar-parent-arrow sidebar-parent-arrow--right">
                    {ds2 ? (
                      <ExpandLess style={{ color: "#34D399" }} />
                    ) : (
                      <ExpandMore style={{ color: "#34D399" }} />
                    )}
                  </span>
                )}
              </ListItem>
            )}
            */}

            {/* ================== COLLAPSE MENU ================== */}

            <Collapse in={ds2} timeout="auto" unmountOnExit>
              <List disablePadding style={{ marginTop: 12 }}>

                {/* PROJECT */}
                {permissions.includes("Project.Show") && (
                  <Tooltip title="Project">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/project");
                      }}
                      className={clsx(
                        hhhh === "/project" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/project"
                            ? "rgba(16,185,129,0.12)"
                            : "rgba(16,185,129,0.05)",

                        border:
                          hhhh === "/project"
                            ? "2px solid #10B981"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fas fa-building"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#10B981" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText
                        primary="Project"
                      />}
                      {open && hhhh === "/project" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#10B981",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* TASKS */}
                {permissions.includes("Tasks.Show") && (
                  <Tooltip title="Tasks">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/tasks");
                      }}
                      className={clsx(
                        hhhh === "/tasks" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/tasks"
                            ? "rgba(16,185,129,0.12)"
                            : "rgba(16,185,129,0.05)",

                        border:
                          hhhh === "/tasks"
                            ? "2px solid #10B981"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fa fa-tasks"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#10B981" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText
                        primary="Tasks"
                      />}
                      {open && hhhh === "/tasks" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#10B981",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

              </List>
            </Collapse>
          </div>



          <div style={{ marginBottom: open ? "20px" : "12px" }}>
            {/* ================== DOCUMENTS (Dashboard Style) ================== */}

            {(permissions.includes("Documentslist.Show") ||
              permissions.includes("Template.Show") ||
              permissions.includes("Emailtemplates.Show")) && (
                <ListItem
                  className="sidebar-parent"
                  button
                  onClick={DocumentClick}
                  style={getParentItemStyle({
                    isActive:
                      hhhh === "/documents/documents-list" ||
                      hhhh === "/templates" ||
                      hhhh === "/email-templates",
                    activeBg: "rgba(217, 119, 6, 0.12)",
                    idleBg: "rgba(217, 119, 6, 0.05)",
                    color: "#D97706",
                  })}
                >
                  <Tooltip title="Documents">
                    <ListItemIcon {...parentIconProps}>
                      {renderParentIconContent({
                        iconClass: "far fa-file-alt",
                        color: "#D97706",
                        expanded: docu,
                      })}
                    </ListItemIcon>
                  </Tooltip>

                  {open && <ListItemText primary="Documents" />}

                  {open && (
                    <span className="sidebar-parent-arrow sidebar-parent-arrow--right">
                      {docu ? (
                        <ExpandLess style={{ color: "#D97706" }} />
                      ) : (
                        <ExpandMore style={{ color: "#D97706" }} />
                      )}
                    </span>
                  )}
                </ListItem>
              )}

            {/* ================== COLLAPSE MENU ================== */}

            {(permissions.includes("Documentslist.Show") ||
              permissions.includes("Template.Show")) && (
                <Collapse in={docu} timeout="auto" unmountOnExit>
                  <List disablePadding style={{ marginTop: 12 }}>

                    {/* TEMPLATE */}
                    {permissions.includes("Template.Show") && (
                      <Tooltip title="Template">
                        <ListItem
                          button
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/templates");
                          }}
                          className={clsx(
                            hhhh === "/templates" && classes.activeMenuItem
                          )}
                          style={{
                            width: open ? "calc(100% - 12px)" : 48,
                            marginLeft: 6,
                            marginBottom: 12,
                            height: 48,
                            borderRadius: 14,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: open ? "flex-start" : "center",
                            paddingLeft: open ? 12 : 0,
                            paddingRight: open ? 12 : 0,
                            transition: "0.3s",
                            boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                            background:
                              hhhh === "/templates"
                                ? "rgba(217, 119, 6, 0.12)"
                                : "rgba(217, 119, 6, 0.05)",

                            border:
                              hhhh === "/templates"
                                ? "2px solid #D97706"
                                : "2px solid transparent",
                          }}
                        >
                          <ListItemIcon style={{
                            minWidth: 48,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 48,
                          }}>
                            <i
                              className="fa fa-file-pdf"
                              style={{ width: 24, textAlign: "center", fontSize: 18, color: "#D97706" }}
                            ></i>
                          </ListItemIcon>

                          {open && <ListItemText
                            primary="Template"
                          />}
                          {open && hhhh === "/templates" && (
                            <i
                              // className="fa fa-chevron-right"
                              style={{
                                marginLeft: "auto",
                                fontSize: 12,
                                color: "#D97706",
                              }}
                            ></i>
                          )}
                        </ListItem>
                      </Tooltip>
                    )}

                    {/* USER DOCUMENTS */}
                    {permissions.includes("Documentslist.Show") && (
                      <Tooltip title="User Documents">
                        <ListItem
                          button
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/documents/documents-list");
                          }}
                          className={clsx(
                            hhhh === "/documents/documents-list" &&
                            classes.activeMenuItem
                          )}
                          style={{
                            width: open ? "calc(100% - 12px)" : 48,
                            marginLeft: 6,
                            marginBottom: 12,
                            height: 48,
                            borderRadius: 14,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: open ? "flex-start" : "center",
                            paddingLeft: open ? 12 : 0,
                            paddingRight: open ? 12 : 0,
                            transition: "0.3s",
                            boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                            background:
                              hhhh === "/documents/documents-list"
                                ? "rgba(217, 119, 6, 0.12)"
                                : "rgba(217, 119, 6, 0.05)",

                            border:
                              hhhh === "/documents/documents-list"
                                ? "2px solid #D97706"
                                : "2px solid transparent",
                          }}
                        >
                          <ListItemIcon style={{
                            minWidth: 48,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 48,
                          }}>
                            <i
                              className="fa fa-file"
                              style={{ width: 24, textAlign: "center", fontSize: 18, color: "#D97706" }}
                            ></i>
                          </ListItemIcon>

                          {open && <ListItemText
                            primary="User Documents"
                          />}
                          {open && hhhh === "/documents/documents-list" && (
                            <i
                              // className="fa fa-chevron-right"
                              style={{
                                marginLeft: "auto",
                                fontSize: 12,
                                color: "#D97706",
                              }}
                            ></i>
                          )}
                        </ListItem>
                      </Tooltip>
                    )}

                    {/* EMAIL TEMPLATES */}
                    {permissions.includes("Emailtemplates.Show") && (
                      <Tooltip title="Email Templates">
                        <ListItem
                          button
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/email-templates");
                          }}
                          className={clsx(
                            hhhh === "/email-templates" &&
                            classes.activeMenuItem
                          )}
                          style={{
                            width: open ? "calc(100% - 12px)" : 48,
                            marginLeft: 6,
                            marginBottom: 12,
                            height: 48,
                            borderRadius: 14,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: open ? "flex-start" : "center",
                            paddingLeft: open ? 12 : 0,
                            paddingRight: open ? 12 : 0,
                            transition: "0.3s",
                            boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                            background:
                              hhhh === "/email-templates"
                                ? "rgba(217, 119, 6, 0.12)"
                                : "rgba(217, 119, 6, 0.05)",

                            border:
                              hhhh === "/email-templates"
                                ? "2px solid #D97706"
                                : "2px solid transparent",
                          }}
                        >
                          <ListItemIcon style={{
                            minWidth: 48,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 48,
                          }}>
                            <i
                              className="fa fa-envelope-square"
                              style={{ width: 24, textAlign: "center", fontSize: 18, color: "#D97706" }}
                            ></i>
                          </ListItemIcon>

                          {open && <ListItemText
                            primary="Email Templates"
                          />}
                          {open && hhhh === "/email-templates" && (
                            <i
                              // className="fa fa-chevron-right"
                              style={{
                                marginLeft: "auto",
                                fontSize: 12,
                                color: "#D97706",
                              }}
                            ></i>
                          )}
                        </ListItem>
                      </Tooltip>
                    )}

                  </List>
                </Collapse>
              )}
          </div>


          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {renderIconGroup(["cron"])}
          </div>

          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {/* ================== FEEDBACK (Dashboard Style) ================== */}

            {(
              (permissions.includes("Form360.Add") && monthsDifference >= 11) ||
              permissions.includes("Reviewformadd.Show") ||
              (permissions.includes("Form360.Show") && ls("roles") === "Employee" && monthsDifference >= 11) ||
              reviewFormStatus === 1
            ) && (
                <ListItem
                  className="sidebar-parent"
                  button
                  onClick={handleClick1}
                  style={getParentItemStyle({
                    isActive: hhhh === "/form360" || hhhh === "/review-form-list",
                    activeBg: "rgba(255,122,184,0.12)",
                    idleBg: "rgba(255,122,184,0.05)",
                    color: "#FF7AB8",
                  })}
                >
                  <Tooltip title="Feedback">
                    <ListItemIcon {...parentIconProps}>
                      {renderParentIconContent({
                        iconClass: "fas fa-file-alt",
                        color: "#FF7AB8",
                        expanded: ds1,
                      })}
                    </ListItemIcon>
                  </Tooltip>

                  {open && <ListItemText primary="Feedback" />}

                  {open && (
                    <span className="sidebar-parent-arrow sidebar-parent-arrow--right">
                      {ds1 ? (
                        <ExpandLess style={{ color: "#FF7AB8" }} />
                      ) : (
                        <ExpandMore style={{ color: "#FF7AB8" }} />
                      )}
                    </span>
                  )}
                </ListItem>
              )}

            {/* ================== COLLAPSE MENU ================== */}

            <Collapse in={ds1} timeout="auto" unmountOnExit>
              <List disablePadding style={{ marginTop: 12 }}>

                {/* FORM360 */}
                {permissions.includes("Form360.Add") && (
                  <Tooltip title="Form360">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/form360");
                      }}
                      className={clsx(
                        hhhh === "/form360" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/form360"
                            ? "rgba(255,122,184,0.12)"
                            : "rgba(255,122,184,0.05)",

                        border:
                          hhhh === "/form360"
                            ? "2px solid #FF7AB8"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fas fa-list-alt"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#FF7AB8" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText
                        primary="Form360"
                      />}
                      {open && hhhh === "/form360" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#FF7AB8",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

                {/* REVIEW FORM LIST */}
                {permissions.includes("Reviewformadd.Show") && (
                  <Tooltip title="Review Form List">
                    <ListItem
                      button
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/review-form-list");
                      }}
                      className={clsx(
                        hhhh === "/review-form-list" && classes.activeMenuItem
                      )}
                      style={{
                        width: open ? "calc(100% - 12px)" : 48,
                        marginLeft: 6,
                        marginBottom: 12,
                        height: 48,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        paddingLeft: open ? 12 : 0,
                        paddingRight: open ? 12 : 0,
                        transition: "0.3s",
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                        background:
                          hhhh === "/review-form-list"
                            ? "rgba(255,122,184,0.12)"
                            : "rgba(255,122,184,0.05)",

                        border:
                          hhhh === "/review-form-list"
                            ? "2px solid #FF7AB8"
                            : "2px solid transparent",
                      }}
                    >
                      <ListItemIcon style={{
                        minWidth: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                      }}>
                        <i
                          className="fas fa-list-ul"
                          style={{ width: 24, textAlign: "center", fontSize: 18, color: "#FF7AB8" }}
                        ></i>
                      </ListItemIcon>

                      {open && <ListItemText
                        primary="Review Form List"
                      />}
                      {open && hhhh === "/review-form-list" && (
                        <i
                          // className="fa fa-chevron-right"
                          style={{
                            marginLeft: "auto",
                            fontSize: 12,
                            color: "#FF7AB8",
                          }}
                        ></i>
                      )}
                    </ListItem>
                  </Tooltip>
                )}

              </List>
            </Collapse>
          </div>


          {/* <div className={hhhh === "/upcoming" ? "slideractive" : ""}> */}
          <div style={{ marginBottom: open ? "20px" : "6px" }}>
            {renderIconGroup(["settings"])}
          </div>


        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.component}
      </main>
    </div>
  );
}


